(function () {
    "use strict";

    angular
        .module("app")
        .controller("userAccessReportController", userAccessReportController);

    // ReSharper disable InconsistentNaming
    function userAccessReportController($q, $rootScope, $state, $scope, cfpLoadingBar, $window, PermissionService, UserService, GridUtil, RoleService, $timeout, ExportService) {// ReSharper restore InconsistentNaming
        var model = this;

        var widthS = 105;
        var widthM = 160;
        var widthL = 210;
        var gridCreated = false;
        model.includeInactive = true;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.goToUserPage = function (id) {
            $state.go("userEdit", { 'userId': id });
        }


        model.init = function () {
            model.setPermissions();

            if (!PermissionService.canReadUsers()) {
                $state.go("permissionDenied");
                return;
            }
            model.setWindowGridHeight();
            //model.initGrid();
            model.loadGrid(1, 50);
            model.loadRoles();

            var filterTimer;
            $scope.$watch("filterText", function (newValue) {
                if (newValue == null)
                    return;

                $timeout.cancel(filterTimer);

                filterTimer = $timeout(function () {
                    model.loadGrid();
                }, 250);
            });
        };

        model.setWindowGridHeight = function () {
            if (window.outerHeight >= 768) {
                $scope.windowGridHeight = window.innerHeight - 315;
            } else if ($scope.pagerData) {
                var size = $scope.pagerData.TotalRecords < $scope.pagerData.PageSize ? $scope.pagerData.TotalRecords : $scope.pagerData.PageSize;
                $scope.windowGridHeight = (size * model.gridOptions.rowHeight) + 46;
            }
        };

        model.setPermissions = function () {
            $scope.canCreateUsers = PermissionService.canCreateUsers();
        };

        model.loadGrid = function (pageNumber, pageSize) {

            model.loadUsers(pageNumber, pageSize).then(function (result) {
                $scope.pagerData = result.Users;
                $scope.users = result.Users.Results;

                if (!gridCreated) {
                    gridCreated = true;
                    model.createGridColumns(result);
                    model.setWindowGridHeight();
                }

                model.gridOptions.api.setRowData(result.Users.Results);
                GridUtil.autoSizeAll(model.gridOptions);
            });
        };

        model.exportData = function () {
            model.loadUsers(1, 9999).then(function (result) {
                ExportService.excelExport({
                    searchResults: result.Users.Results,
                    columns: model.gridOptions.columnApi.getColumnState(),
                    columnDefs: model.columnDefs,
                    reportName: "Users",
                    useFriendlyHeaders: true
                });
            });
        };

        model.filterRoles = function (t) {
            model.includeInactive = t;
            model.gridOptions.api.showLoadingOverlay();
            model.loadGrid($scope.pagerData.CurrentPageNumber, $scope.pagerData.PageSize);
        }

        var canceller;
        model.loadUsers = function (pageNumber, pageSize) {
            if (canceller) {
                canceller.cancel("cancelled");
                canceller = null;
            }

            if (!pageNumber && $scope.pagerData)
                pageNumber = $scope.pagerData.CurrentPageNumber;
            if (!pageSize && $scope.pagerData)
                pageSize = $scope.pagerData.PageSize;

            var q = $q.defer();
            var promise = UserService.getUserAccessReport({ pageNumber: pageNumber, pageSize: pageSize, roleId: $scope.selectedRole, searchText: $scope.filterText, IncludeInactive: model.includeInactive });
            canceller = promise.canceller;

            promise.then(function (result) {
                if (result === "cancelled") {
                    q.reject(result);
                    return;
                }

                angular.forEach(result.Users.Results, function (user) {
                    user.RoleName = user.Role ? user.Role.RoleName : "N/A";
                    angular.forEach(user.Brands, function (brand) { user[brand.BrandName.replace("'", "")] = true; });
                    angular.forEach(user.ModulePermissions, function (module) { user[module.Key] = true; });
                });

                q.resolve(result);
            });

            return q.promise;
        };

        model.loadRoles = function () {
            RoleService.getAllRoles().then(function (response) {
                $scope.roles = response;
                $scope.selectedRole = [];
                $scope.selectedRoles = [];
                $scope.roleSelected = function () {
                    model.gridOptions.api.showLoadingOverlay();
                    model.loadGrid();
                };
            });
        };

        model.initGrid = function () {
            model.gridOptions = {
                rowHeight: 30,
                enableColResize: true,
                enableFilter: false,
                enableSorting: true,
                paginationPageSize: 15,
                rowSelection: 'single',
                suppressCellSelection: true,
                suppressContextMenu: true,
                suppressMultiSort: true,
                suppressSorting: false,
                suppressDragLeaveHidesColumns: true,
                suppressMovableColumns: true,
                suppressRowHoverClass: true,
                suppressColumnMoveAnimation: true,
                suppressColumnVirtualisation: true,
                showToolPanel: false,
                overlayLoadingTemplate: '<div id="mini-loader"></div>',
                onCellClicked: function (event) {
                    $state.go("userEdit", { 'userId': event.data.UserId });
                }
            };

            var gridDiv = document.querySelector("#usersGrid");
            new agGrid.Grid(gridDiv, model.gridOptions);
        };

        model.createGridColumns = function (userReport) {
            model.columnDefs = [
                { field: "UserId", headerName: "UserId", hide: true, suppressColumnVirtualisation: true, editable: false, pinned: "left", menuTabs: []},
                { field: "Username", headerName: "Username", suppressColumnVirtualisation: true, editable: false, pinned: "left", menuTabs: []},
                { field: "FirstName", headerName: "First Name", editable: false, suppressColumnVirtualisation: true, pinned: "left", menuTabs: [] },
                { field: "LastName", headerName: "Last Name", editable: false, suppressColumnVirtualisation: true, pinned: "left", menuTabs: []},
                { field: "IsActive", headerName: "Active", cellRenderer: GridUtil.check, editable: false, suppressColumnVirtualisation: true, pinned: "left", menuTabs: [] },
                { field: "LastLogin", headerName: "Last Login", cellRenderer: GridUtil.dateParse, editable: false, suppressColumnVirtualisation: true, width: widthS, menuTabs: [] },
                { field: "RoleName", headerName: "Role", editable: false, suppressColumnVirtualisation: true, width: widthL, menuTabs: []},
                { field: "IsFactoryUser", headerName: "Factory User", cellRenderer: GridUtil.check, editable: false, suppressColumnVirtualisation: true, width: widthS, cellClass: "text-center", menuTabs: []},
                { field: "Factories", headerName: "Factories", editable: false, suppressColumnVirtualisation: true, width: widthM, menuTabs: []},
                { field: "Created", headerName: "Created", cellRenderer: GridUtil.dateParse, editable: false, suppressColumnVirtualisation: true, width: widthS, menuTabs: [] },
                { field: "CreatedBy", headerName: "Created By", editable: false, suppressColumnVirtualisation: true, width: widthL, menuTabs: []},
                { field: "LastChanged", headerName: "Modified", cellRenderer: GridUtil.dateParse, editable: false, suppressColumnVirtualisation: true, width: widthS, menuTabs: [] },
                { field: "LastChangedBy", headerName: "Modified By", editable: false, suppressColumnVirtualisation: true, width: widthL, menuTabs: []}
            ];

            angular.forEach(userReport.AllBrands, function (brand) {
                model.columnDefs.push({ field: brand.BrandName.replace("'", ""), headerName: brand.BrandName.replace("'", ""), cellRenderer: GridUtil.check, editable: false, suppressColumnVirtualisation: true, width: widthS, cellClass: "text-center", menuTabs: []});
            });

            angular.forEach(userReport.AllModulePermissions, function (module) {
                model.columnDefs.push({ field: module.Key, headerName: module.Module + " " + module.Permission, cellRenderer: GridUtil.check, editable: false, suppressColumnVirtualisation: true, width: widthS, cellClass: "text-center", menuTabs: []});
            });

            model.gridOptions.api.setColumnDefs(model.columnDefs);
        };

        //toggle role
        $scope.toggleRoleFilter = function () {
            $scope.openRoleFilter = !$scope.openRoleFilter;
            if ($scope.openRoleFilter) {
                document.getElementById('')
            }
            $scope.openRoleFilterFocus = true;
        }

        //add role filter and reload list
        var roleCountdown;
        $scope.addRoleFilter = function (item) {
            $scope.progress = false;
            var findRole = $scope.selectedRole.indexOf(item.RoleId);
            if (findRole === -1) {
                $scope.selectedRole.push(item.RoleId);
                $scope.selectedRoles.push(item.RoleName);
                item.isSelected = true;
            } else {
                $scope.selectedRole.splice(findRole, 1);
                $scope.selectedRoles.splice(findRole, 1);
                item.isSelected = false;
            }

            //get new data with role filters
            $timeout(function () {
                $scope.progress = true;
            },0)
            $timeout.cancel(roleCountdown);
            roleCountdown = $timeout(function () {
                $scope.roleSelected();
                $scope.progress = false;
            },1500)
        }

        $scope.searchRoles = function () {
            $scope.roleFilter = $scope.roleFilterSearch;
            $scope.roleActionDisplay = false;
        }

        //make friendly roles
        $scope.friendlyRoles = function (roles) {
            if (roles)
                return roles.toString().replace(/"|[|]/g, '').replace(/,/g, ', ');
        }

        //clear all roles (button)
        $scope.clearRoleFilter = function () {
            $scope.selectedRole = []; //clear selected role for data
            $scope.selectedRoles = []; //clear selected roles for friendly display
            $scope.roleSelected(); //get data with no filtered roles

            angular.forEach($scope.roles, function (k, v) {
                k.isSelected = false;
            });
        }

        //Function for Action buttons
        $scope.selectedRoleFilter = function () {
            $scope.roleActionDisplay = !$scope.roleActionDisplay;
            if ($scope.roleActionDisplay) {
                $scope.roleFilter = { isSelected: true };
                $scope.roleFilterSearch = "";
            } else {
                $scope.roleFilter = "";
                $scope.roleFilterSearch = "";
            }
        }

        //get role dropdown to behave like a regular select
        $window.addEventListener('click', function (e) {
            var close = true;
            angular.forEach(e.path, function (k, v) {
                if (k.id === "role-filter")
                    close = false;
            });
            if (close && $scope.openRoleFilter) {
                $scope.toggleRoleFilter();
                $scope.$evalAsync(); //otherwise wont properly execute toggleRoleFilter();
            }
        })
        //model.init();
    }
})();
